import IResult from "../../models/result/IResult";
import { sendGet, sendPost, sendPut } from "./generic";
import { MEDICAL_INTEGRATION_CONFIGURATION } from "../../constants/Urls";
import MedicalIntegrationConfigModel from "../../models/organizations/MedicalIntegrationConfigModel";

export const getMedicalIntegrationConfigsByOrganizationId = (organizationId: string): Promise<IResult<MedicalIntegrationConfigModel[]>> => {
    return sendGet<MedicalIntegrationConfigModel[]>(`${MEDICAL_INTEGRATION_CONFIGURATION}/${organizationId}`);
}

export const createMedicalIntegrationConfig = (model: MedicalIntegrationConfigModel): Promise<IResult<MedicalIntegrationConfigModel>> => {
    return sendPost<MedicalIntegrationConfigModel>(`${MEDICAL_INTEGRATION_CONFIGURATION}`, model);
}

export const updateMedicalIntegrationConfig = (configId: string, model: MedicalIntegrationConfigModel): Promise<IResult<MedicalIntegrationConfigModel>> => {
    return sendPut<MedicalIntegrationConfigModel>(`${MEDICAL_INTEGRATION_CONFIGURATION}/${configId}`, model);
}
